function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "void-icon",
  transform: "translate(0.75 0.75)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Grupo_508",
  "data-name": "Grupo 508",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Caminho_845",
  "data-name": "Caminho 845",
  d: "M57.15,64.694a9.969,9.969,0,1,1,9.969-9.969A9.98,9.98,0,0,1,57.15,64.694Zm0-18.72a8.751,8.751,0,1,0,8.75,8.75A8.761,8.761,0,0,0,57.15,45.975Z",
  transform: "translate(-47.181 -44.756)",
  fill: "#00a9ff",
  stroke: "#00a9ff",
  strokeWidth: 1.5
})), /*#__PURE__*/React.createElement("g", {
  id: "Grupo_517",
  "data-name": "Grupo 517",
  transform: "translate(3.245 2.784) rotate(45)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Ret\\xE2ngulo_1409",
  "data-name": "Ret\\xE2ngulo 1409",
  width: 19.028,
  height: 1.297,
  fill: "#00a9ff",
  stroke: "#00a9ff",
  strokeWidth: 1.5
})));

function SvgVoidIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.438,
    height: 21.438,
    viewBox: "0 0 21.438 21.438",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoidIcon);
export default __webpack_public_path__ + "static/media/void-icon.42912e36.svg";
export { ForwardRef as ReactComponent };